<template>
  <b-modal
    id="modal_form"
    ref="modal_form"
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    no-close-on-backdrop
    cancel-title="Cancelar"
    :ok-disabled="form.errors.any()"
    v-model="showModal"
    @ok="onStore"
  >
    <form
      @submit.stop.prevent="onStore"
      @keydown="form.errors.clear($event.target.name)"
    >
      <b-row>
        <b-col>
          <label tag="div">Tipo de Documento</label>
          <b-form-group>
            <b-form-radio-group
              v-model="form.tp_doc"
              :options="optionsTpDoc"
              name="tp_doc"
              plain
              value-field="value"
            ></b-form-radio-group>
          </b-form-group>
          <b-form-feedback
            v-text="form.errors.get('tp_doc')"
            v-if="form.errors.has('tp_doc')"
          ></b-form-feedback>
        </b-col>
      </b-row>
      <b-row  v-if="form.tp_doc == 1 || form.tp_doc == 2">
        <b-col>
          <label tag="div">Chave </label>
          <b-form-input
            type="text"
            placeholder="Chave"
            v-model="form.chave"
            name="nome"
          >
          </b-form-input>
          <b-form-feedback
            v-text="form.errors.get('chave')"
            v-if="form.errors.has('chave')"
          ></b-form-feedback>
        </b-col>
      </b-row>
      <b-row v-if="form.tp_doc == 3">
        <b-col>
          <label tag="div">Num Fiscal </label>
          <b-form-input
              type="text"
              placeholder="Chave"
              v-model="form.num_fiscal"
              name="nome"
          >
          </b-form-input>
          <b-form-feedback
              v-text="form.errors.get('num_fiscal')"
              v-if="form.errors.has('num_fiscal')"
          ></b-form-feedback>
        </b-col>
        <b-col>
          <label tag="div">Série</label>
          <b-form-input
              type="text"
              placeholder="Série"
              v-model="form.serie"
              name="nome"
          >
          </b-form-input>
          <b-form-feedback
              v-text="form.errors.get('serie')"
              v-if="form.errors.has('serie')"
          ></b-form-feedback>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label tag="div">Volume</label>
          <b-form-input
            type="number"
            placeholder="Volumes (Opcional)"
            v-model="form.volume"
            name="volume"
            :disabled="this.form.tp_doc == 1 || this.form.tp_doc == '' || this.form.tp_doc === 3"
          >
          </b-form-input>
          <b-form-feedback
            v-text="form.errors.get('volume')"
            v-if="form.errors.has('volume')"
          ></b-form-feedback>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-md-6" v-if="form.tp_doc != 2">
          <label tag="div">Faixa Inicial</label>
          <b-form-input
              type="number"
              placeholder="Numero Inicial"
              v-model="form.num_fiscal_inicial"
              name="num_fiscal_inicial"
          >
          </b-form-input>
          <b-form-feedback
              v-text="form.errors.get('num_fiscal_inicial')"
              v-if="form.errors.has('num_fiscal_inicial')"
          ></b-form-feedback>
        </b-col>
        <b-col class="col-md-6" v-if="form.tp_doc != 2">
          <label tag="div">Faixa Final</label>
          <b-form-input
              type="number"
              placeholder="Numero Final"
              v-model="form.num_fiscal_final"
              name="num_fiscal_final"
          >
          </b-form-input>
          <b-form-feedback
              v-text="form.errors.get('num_fiscal_final')"
              v-if="form.errors.has('num_fiscal_final')"
          ></b-form-feedback>
        </b-col>
        <b-col class="col-md-6" v-if="form.tp_doc == 2">
          <label tag="div">Numero Fiscal</label>
          <b-form-input
              type="number"
              placeholder="Numero Fiscal"
              v-model="form.num_fiscal"
              name="num_fiscal_inicial"
          >
          </b-form-input>
          <b-form-feedback
              v-text="form.errors.get('num_fiscal')"
              v-if="form.errors.has('num_fiscal')"
          ></b-form-feedback>
        </b-col>
        <b-col class="col-md-6" v-if="form.tp_doc == 2">
          <label tag="div">Série</label>
          <b-form-input
              type="number"
              placeholder="Série"
              v-model="form.serie"
              name="serie"
          >
          </b-form-input>
          <b-form-feedback
              v-text="form.errors.get('serie')"
              v-if="form.errors.has('serie')"
          ></b-form-feedback>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-md-6">
          <label></label>
          <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Data Inicial"
              v-model="form.dt_inicio"
              class="form-control"
              :date-format-options="{
                          day: 'numeric',
                          month: 'numeric',
                          year: 'numeric',
                        }"
          >
          </b-form-datepicker>
          <b-form-feedback
              v-text="form.errors.get('dt_inicio')"
              v-if="form.errors.has('dt_inicio')"
          ></b-form-feedback>
        </b-col>
        <b-col class="col-md-6">
          <label></label>
          <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Data Fim"
              v-model="form.dt_fim"
              class="form-control"
              :date-format-options="{
                          day: 'numeric',
                          month: 'numeric',
                          year: 'numeric',
                        }"
          >
          </b-form-datepicker>
          <b-form-feedback
              v-text="form.errors.get('dt_fim')"
              v-if="form.errors.has('dt_fim')"
          ></b-form-feedback>
        </b-col>
      </b-row>
    </form>
    <div slot="modal-footer" class="w-100">
      <div class="float-left">
        <spinner v-if="loading" message="Processando..."></spinner>
      </div>
      <div class="float-right">
        <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
        <b-btn @click="showModal = false" variant="secondary"> Fechar </b-btn>
        <b-btn @click="onStore()" variant="secondary" :disabled="isDisabled">
          Enviar
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>
<script>
import AvisoErros from "../components/AvisoErros";

export default {
  components: {
    AvisoErros
  },
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: ""
  },
  data() {
    return {
      dataExport: [],
      codOcorrencia: [],
      optionsTpDoc: [{text: 'CTE', value: 1}, {text: 'NFE', value: 2}, {text: 'RPS', value: 3}],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      showPopover: false,
      errors_array: [],
      data: [],
      form: new Form({
        tp_doc: '',
        chave: '',
        volume: '',
        num_fiscal: '',
        num_fiscal_inicial: '',
        num_fiscal_final: '',
        dt_inicio: '',
        dt_fim: '',
        serie: ''
      }),
      helpForm: new Form({ statusRecord: [], params: [] }),
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger"
      },
      moreParams: {}
    };
  },
  watch: {
    codOcorrencia(obj) {
      this.fileForm.cd_ocorrencia = obj.value;
    }
  },
  methods: {
    onCreate() {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.errors_array = "";
      this.errors_array = [];
      this.form.reset();
      this.$refs.modal_form.show();
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;

      if(this.form.tp_doc === 1) {
        this.form.serie = '';
        this.form.volume = ''
      }


      if(this.form.tp_doc === 3) {
        this.form.volume = ''
      }

      this.form
        .post("/api/cte/imprimir/etiqueta")
        .then(response => {
          new ReturnApi(response, this, true, null, null, true);
        })
        .catch(errors => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach(obj => {
                  this.errors_array.push({
                    erro: obj
                  });
                });
              }
            }
          }
        });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      console.log(id);
      this.form
        .patch("/api/feriado/update/" + id)
        .then(response => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch(errors => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach(obj => {
                  this.errors_array.push({
                    erro: obj
                  });
                });
              }
            }
          }
        });
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    }
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      }
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      }
    }
  }
};
</script>
